import { useMemo } from "react";
import { queries } from "../../../../shared/queries";
import { useQuery } from "../../../hooks/useQuery";
import { type ColumnItem, FileBrowserColumn } from "../FileBrowserColumn";

type Props = {
  selectedId: string | null;
  focusedColumn: boolean;
  focusedIndex: number;
  columnIndex: number;
  onSelect: (
    id: string,
    label: string,
    rowIndex: number,
    meta?: Record<string, string>
  ) => void;
  onReplace?: (
    id: string,
    label: string,
    meta?: Record<string, string>
  ) => void;
  onRegisterCount: (columnIndex: number, count: number) => void;
};

export function PersonalVolumesColumn(props: Props) {
  const [volumes] = useQuery(queries.personalVolumes());

  const items: ColumnItem[] = useMemo(
    () =>
      volumes.map((v) => ({
        id: v.name,
        label: v.name,
        icon: "save" as const,
      })),
    [volumes]
  );

  return <FileBrowserColumn heading="Volumes" items={items} {...props} />;
}
